import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "../../../utils/theme";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

import { useDataContex } from "../../../hooks/Context/PatientProvider";
// import Paginator from "../../Paginator";

import Select from "../PatiendContactComponet/FormInput/Select";

import { useNavigate } from "react-router-dom";
import { IPatientInsurance, ISelectOption } from "../../../interfaces/Patient";

const ContainerOrder = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }

  .arrow {
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.primary};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

const ContainerFormOrder = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const FormInputOrder = styled.div`
  width: 40%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  @media (max-width: 1024px) {
    width: 80%;
  }

  label {
    color: ${colors.third};
    font-weight: 600;
    width: 70%;
    @media (max-width: 500px) {
      width: 100%;
    }
  }

  option {
    color: ${colors.fifth};
  }

  .entidad {
    width: 70%;
    align-self: flex-end;
    @media (max-width: 1024px) {
      align-self: normal;
      width: 100%;
    }
  }

  .area {
    width: 70%;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 30%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

export const InfoOrderComponent = () => {
  // estados
  const navigate = useNavigate();
  // estados para manejar los fetch
  const [razonesSociales, setRazonesSociales] = useState<ISelectOption[]>([]);
  const [areasAfectadas, setAreasAfectadas] = useState<ISelectOption[]>([]);

  const [formData, setFormData] = useState<IPatientInsurance>({
    policy: { field: "", isValid: null }, // Cambia a null
    zone: { field: "", isValid: null }, // Cambia a null
  });

  // contexto para compartir el esatdo que vienen de los formulario
  const { setData2, data, setHorariosData } = useDataContex();
  const allFieldsValid = Object.values(formData).every(
    (field) => field.isValid
  );

  // se navega la ruta de paciente nuevo si todavia no hay data en el compoenente
  useEffect(() => {
    if (!data || data.length === 0) {
      navigate("/PacienteNuevo");
    }
  }, [data, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "/apihub/legacy/odata/Poliza?$filter=habilitado eq 1"
        );
        if (!response.ok) {
          throw new Error("Error en la solicitud");
        }
        let tipoPoliza;
        const rawData = await response.text();
        const data = JSON.parse(rawData);
        const opcionesRazonesSociales = data.value.map((item) => {
          if (item.TipoPoliza === 10) {
            tipoPoliza = 'ARL - ';
          } else if (item.TipoPoliza === 20) {
            tipoPoliza = 'PRE - ';
          } else if (item.TipoPoliza === 30) {
            tipoPoliza = 'PAR - ';
          } else if (item.TipoPoliza === 40) {
            tipoPoliza = 'EPS - ';
          } else {
            tipoPoliza = 'NO - ';
          }
         
          
          return {
            value: item.IdHc,
            label: tipoPoliza + " " + item.RazonSocial,
          };
        });
        setRazonesSociales(opcionesRazonesSociales);
      } catch (error) {
        console.error("Error al realizar la solicitud:", error);
      }

      try {
        const response = await fetch("/apihub/legacy/odata/Proc");
        if (!response.ok) {
          throw new Error("Error en la solicitud");
        }
        const rawData = await response.text();
        const data = JSON.parse(rawData);
        const Procedimientos = data.value.map((item: any) => ({
          value: item.Id,
          label: item.Name,
        }));
        
        setAreasAfectadas(Procedimientos);
      } catch (error) {
        console.error("Error al realizar la solicitud:", error);
      }
    };

    fetchData();
  }, []);

  async function postHorariosDisponibles(areaAfectada, fromDate, toDate) {
    const url = "/apihub/legacy/Service/Agenda/HorariosDisponibles";
    const requestBody = {
      areaAfectada: areaAfectada,
      fromDate: fromDate,
      toDate: toDate,
    };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error en la solicitud POST:", error);
    }
  }

  const onSutmit = (e) => {
    e.preventDefault();
    if (allFieldsValid) {
      Swal.fire({
        title: "¡Formulario exitoso!",
        text: "Campos correctos",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      setTimeout(() => {
        navigate("/ConfirmarCita");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split("T")[0];
        const fromDate = formattedDate.substring(0, 10);
        const fromTo = new Date(fromDate);
        fromTo.setDate(fromTo.getDate() + 15);
        const toDate = fromTo.toISOString().split("T")[0];
        postHorariosDisponibles("MUÑECA Y MANO", fromDate, toDate)
          .then((data) => {
            setHorariosData(data);
          })
          .catch((error) => console.error(error));
      }, 1500);

      setData2([formData]);
    } else {
      const updatedFormData = { ...formData };

      for (const key in updatedFormData) {
        updatedFormData[key].isValid = updatedFormData[key].isValid === true;
      }
      setFormData(updatedFormData);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Rellene todos lo campos faltante!",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#ec2323",
      });
    }
  };
  const handleNavigation = () => {
    if (allFieldsValid) {
      setData2((prev) => [...prev, formData]);
      Swal.fire({
        title: "¡Formulario exitoso!",
        text: "Campos correctos",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      setTimeout(() => {
        navigate("/ConfirmarCita");
      }, 1500);
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "rellene los campos antes de pasar a la siguiente pagina!",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#ec2323",
      });
    }
  };
  return (
    <ContainerOrder>
      {/* <Paginator
        prevRoute="/contacto"
        nextRoute="/ConfirmarCita"
        title="INFORMACIÓN DE ORDEN MÉDICA"
      /> */}

      <div className="paginator">
        <Link className="arrow" to="/PacienteNuevo">
          <i className="bx bx-chevron-left"></i>
        </Link>
        <span className="title1">INFORMACIÓN DE ORDEN MÉDICA</span>
        <span className="arrow" onClick={handleNavigation}>
          <i className="bx bx-chevron-right"></i>
        </span>
      </div>

      <form onSubmit={onSutmit}>
        <ContainerFormOrder>
          <FormInputOrder>
            <label className="entidad">ENTIDAD</label>
            <div className="entidad">
              <Select
                state={formData.policy}
                changeState={(newState) =>
                  setFormData({ ...formData, policy: newState })
                }
                placeholder="Seleccione..."
                options={razonesSociales}
                nameOption="razonesSociales"
                legendError="Eliga Su Poliza"
              />
            </div>
          </FormInputOrder>

          <FormInputOrder>
            <label className="area">ÁREA AFECTADA</label>
            <div className="area">
              <Select
                state={formData.zone}
                changeState={(newState) =>
                  setFormData({ ...formData, zone: newState })
                }
                placeholder="Seleccione..."
                options={areasAfectadas}
                nameOption="areasAfectadas"
                legendError="Eliga Su Area Afectada"
              />
            </div>
          </FormInputOrder>
        </ContainerFormOrder>

        <ContainerButton>
          {/* <Link className="button" to="/ConfirmarCita">
          CONTINUAR AGENDAMIENTO
        </Link> */}
          <button className="button" type="submit">
            CONTINUAR AGENDAMIENTO
          </button>
        </ContainerButton>
      </form>
    </ContainerOrder>
  );
};
